import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
const EXTENSION_IDENTIFIER_PATTERN = '^([a-z0-9A-Z][a-z0-9-A-Z]*)\\.([a-z0-9A-Z][a-z0-9-A-Z]*)$';
const IExtensionGalleryService = ( createDecorator('extensionGalleryService'));
const IExtensionManagementService = ( createDecorator('extensionManagementService'));
export { EXTENSION_IDENTIFIER_PATTERN, IExtensionGalleryService, IExtensionManagementService };
